module.exports = __webpack_public_path__ + "static/media/orox-homepage.ce461d34.png";